export default __webpack_public_path__ + "static/media/zinier-logo-with-name-black.b230f552.svg";